module.exports = __webpack_public_path__ + "img/alert.8e7c6037.svg";